var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$_project),expression:"$_project"}]},[_c('NavTop',{attrs:{"params":{search: false, projectNav: true}}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }